import { Vertical } from '@gravitate-js/excalibrr'
import { useEffect } from 'react'
import { useCrossroadsCompanies } from '../../api/hooks/useCrossroadsNetwork'
import { ErrorBoundary } from '../../components/ErrorBoundary'
import { CompanyMapper } from '../../utils/companyMapper'
import { ConnectionLogsPanel } from './panels/ConnectionLogsPanel'
import { ReferenceDataPanel } from './panels/ReferenceDataPanel/ReferenceDataPanel'
import { SupplyPlanLogsPanel } from './panels/SupplyPlanLogsPanel'

export function Dashboard() {
  const page = window.location.pathname.split('/').pop() || ''
  // Fetch companies on dashboard load and populate the company mapper
  const { data: companies } = useCrossroadsCompanies()

  useEffect(() => {
    if (companies && companies.length > 0) {
      const mapper = CompanyMapper.getInstance()
      mapper.setCompanies(companies)
    }
  }, [companies])

  return (
    <ErrorBoundary>
      <Vertical>
        <Vertical className='pt-2'>
          {page === 'reference-data' && <ReferenceDataPanel />}
          {page === 'connection-logs' && <ConnectionLogsPanel />}
          {page === 'supply-plan-logs' && <SupplyPlanLogsPanel />}
        </Vertical>
      </Vertical>
    </ErrorBoundary>
  )
}
